<template>
    <div class="offer-section">
        <div class="container">
            <div class="row">
                <div class="col-md-12">


                    <div class="offer-filter">
                        <div class="toggler">
                            <button class="toggler-btn " :class="{'active': showfilter}" @click="showfilters">{{showfilterText}} <img src="/img/icon/arrow-down-black.svg" alt=""></button>
                        </div>
                        <transition name="fade">
                            <div  class="main-filter open" v-if="showfilter">
                                <div class="row">
                                    <div class="col-md-6 col-lg-3">
                                        <div class="filter-blck filter-dropdown" v-click-outside="closetoogleshow">
                                            <label class="min p-dgrey">Contract type</label>
                                            <button class="btn btn-white btn-full small dropdown"
                                                    @click="show = !show">Sun, wind, water, Nature</button>
                                            <transition name="fade">
                                                <div class="dropdown__el" v-if="show">
                                                    <div class="dropdown-list">
                                                        <div class="dropdown-item">
                                                                    <span class="checkbox">
                                                                        <input type="checkbox" title="title">
                                                                        <span class="box"></span>
                                                                    </span>
                                                            <label>Fixed price 6 months</label>
                                                        </div>
                                                        <div class="dropdown-item">
                                                                    <span class="checkbox">
                                                                        <input type="checkbox" title="title">
                                                                        <span class="box"></span>
                                                                    </span>
                                                            <label>Fixed price 6 months</label>
                                                        </div>
                                                        <div class="dropdown-item">
                                                                    <span class="checkbox">
                                                                        <input type="checkbox" title="title">
                                                                        <span class="box"></span>
                                                                    </span>
                                                            <label>Fixed price 6 months</label>
                                                        </div>
                                                        <div class="dropdown-item">
                                                                    <span class="checkbox">
                                                                        <input type="checkbox" title="title">
                                                                        <span class="box"></span>
                                                                    </span>
                                                            <label>Fixed price 6 months</label>
                                                        </div>
                                                        <div class="dropdown-item">
                                                                    <span class="checkbox">
                                                                        <input type="checkbox" title="title">
                                                                        <span class="box"></span>
                                                                    </span>
                                                            <label>Fixed price 6 months</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </transition>
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-lg-3">
                                        <div class="filter-blck filter-dropdown" v-click-outside="closetoogleshow2">
                                            <label class="min p-dgrey">Contract type</label>
                                            <button class="btn btn-white btn-full small dropdown"
                                                    @click="show2 = !show2">Some long text without dashes</button>
                                            <transition name="fade">
                                                <div class="dropdown__el" v-if="show2">
                                                    <div class="dropdown-list">
                                                        <div class="dropdown-item">
                                                            <img src="/img/icon/weather/sun.svg" alt="">
                                                            <span class="checkbox">
                                                                        <input type="checkbox" title="title">
                                                                        <span class="box"></span>
                                                                    </span>
                                                            <label>Sun</label>
                                                        </div>
                                                        <div class="dropdown-item">
                                                            <img src="/img/icon/weather/wind.svg" alt="">
                                                            <span class="checkbox">
                                                                        <input type="checkbox" title="title">
                                                                        <span class="box"></span>
                                                                    </span>
                                                            <label>Wind</label>
                                                        </div>
                                                        <div class="dropdown-item">
                                                            <img src="/img/icon/weather/drop.svg" alt="">
                                                            <span class="checkbox">
                                                                        <input type="checkbox" title="title">
                                                                        <span class="box"></span>
                                                                    </span>
                                                            <label>Water</label>
                                                        </div>
                                                        <div class="dropdown-item">
                                                            <img src="/img/icon/weather/leaf.svg" alt="">
                                                            <span class="checkbox">
                                                                        <input type="checkbox" title="title">
                                                                        <span class="box"></span>
                                                                    </span>
                                                            <label>Nature</label>
                                                        </div>
                                                        <div class="dropdown-item">
                                                            <img src="/img/icon/weather/ecology.svg" alt="">
                                                            <span class="checkbox">
                                                                        <input type="checkbox" title="title">
                                                                        <span class="box"></span>
                                                                    </span>
                                                            <label>Good environmental choice</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </transition>
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-lg-3">
                                        <div class="filter-blck filter-dropdown" v-click-outside="closetoogleshow3">
                                            <label class="min p-dgrey">Contract type</label>
                                            <button class="btn btn-white btn-full small dropdown"  @click="show3 = !show3">All types</button>
                                            <transition name="fade">
                                                <div class="dropdown__el" v-if="show3">
                                                    <div class="dropdown-list">
                                                        <div class="dropdown-item">
                                                            <img src="/img/icon/autogiro.svg" alt="">
                                                            <span class="checkbox">
                                                                        <input type="checkbox" title="title">
                                                                        <span class="box"></span>
                                                                    </span>
                                                            <label>Autogiro</label>dw
                                                        </div>
                                                        <div class="dropdown-item">
                                                            <img src="/img/icon/check.svg" alt="">
                                                            <span class="checkbox">
                                                                        <input type="checkbox" title="title">
                                                                        <span class="box"></span>
                                                                    </span>
                                                            <label>E-faktura</label>
                                                        </div>
                                                        <div class="dropdown-item">
                                                            <img src="/img/icon/file.svg" alt="">
                                                            <span class="checkbox">
                                                                        <input type="checkbox" title="title">
                                                                        <span class="box"></span>
                                                                    </span>
                                                            <label>Traditionell</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </transition>
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-lg-3 d-flex align-items-end justify-content-start">
                                        <div class="filter-blck eco">
                                            <!--checkbox error add class "check-error"-->
                                            <span class="checkbox">
                                                   <input type="checkbox" title="title">
                                                   <span class="box"></span>
                                               </span>
                                            <label class="min-min p-dgrey">Good environmental choice</label>
                                            <img src="/img/icon/ecology.svg" alt="">
                                            <!--end error-->
                                        </div>
                                    </div>
                                </div>
                                <div class="row justify-content-center">
                                    <div class="col-md-4 col-lg-3">
                                        <button class="btn btn-blue btn-full small">Apply filters</button>
                                    </div>
                                </div>


                        </div>
                        </transition>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="offer-result">
                        <div class="title-row">
                           <div class="row">
                               <div class="col-xl-7">
                                   <p class="p-title relawayBold p-black"><b>Your result</b></p>
                                   <p class="Raleway min-med p-dgrey">We found <b>188</b> electricity contracts that fit your preferences!</p>
                               </div>
                               <div class="col-xl-5">
                                   <div class="sort__blck">
                                       <p class="Raleway med p-black mb-0"><b>Sort by:</b></p>
                                       <div class="filter-blck filter-dropdown" v-click-outside="closetoogleshow4">
                                           <button class="btn btn-full btn-white small dropdown" @click="show4 = !show4">Fixed price 1 year</button>
                                           <transition name="fade">
                                               <div class="dropdown__el" v-if="show4">
                                                   <div class="dropdown-list">
                                                       <div class="dropdown-item">Fixed price 6 months</div>
                                                       <div class="dropdown-item">Fixed price 6 months</div>
                                                       <div class="dropdown-item">Fixed price 6 months </div>
                                                       <div class="dropdown-item">Fixed price 6 months</div>
                                                       <div class="dropdown-item">Fixed price 6 months</div>
                                                   </div>
                                               </div>
                                           </transition>
                                       </div>
                                   </div>

                               </div>
                           </div>
                        </div>
                        <div class="result__blck">
                            <div class="result_list">
                                <div class="result__title text-center">
                                        <p class="p-center black med Raleway"><b>Fixed price 1 year</b></p>
                                </div>
                                <div class="result_items">
                                    <offer-result
                                            v-for="resultItem in res"
                                            :itemData="resultItem"
                                            :key="resultItem.id"
                                            @modalActive="openModal()"
                                            :typeEnergy = "resultItem.typeenergy"
                                    ></offer-result>
                                </div>
                            </div>
                            <div class="result_list">
                                <div class="result__title text-center">
                                    <p class="p-center black med Raleway"><b>Fixed price 1 year</b></p>
                                </div>
                                <div class="result_items">
                                    <offer-result
                                            v-for="resultItem in res2"
                                            :itemData="resultItem"
                                            :key="resultItem.id"
                                            @modalActive="openModal()"
                                    ></offer-result>

                                </div>

                            </div>
                            <div class="show-more p-center">
                                <button class="btn btn-blue small" 
                                        :class="{'load':preloaded}" 
                                        :disabled="preloaded"
                                        @click="preloadBlock">
                                    Show more (Total: 95)
                                        <span v-if="preloaded">
                                            <img src="/img/tail-spin.svg" alt="">
                                        </span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div class="info-popup open" v-if="modal">
            <div class="popupoverlay"   @click="closeModal()"></div>
            <div class="mainpopup">
                <div class="close" @click="closeModal()"></div>
                <div class="popup_body">

                    <div class="title">
                        <p class="Raleway p-black max-max"><b>Info</b></p>
                    </div>
                    <div class="content min-min">
                        <p class="min-min"> It is currently not possible to get our help with the change to this
                            company, as they lack a cooperation with el skling.se.</p>
                        <p class="min-min"> It is currently not possible to get our help with the change to this
                            company, as they lack a cooperation with el skling.se.</p>
                        <p class="min-min"> It is currently not possible to get our help with the change to this
                            company, as they lack a cooperation with el skling.se.</p>
                        <p class="min-min"> It is currently not possible to get our help with the change to this
                            company, as they lack a cooperation with el skling.se.</p>
                        <p class="min-min"> It is currently not possible to get our help with the change to this
                            company, as they lack a cooperation with el skling.se.</p>
                        <p class="min-min"> It is currently not possible to get our help with the change to this
                            company, as they lack a cooperation with el skling.se.</p>
                        <p class="min-min"> It is currently not possible to get our help with the change to this
                            company, as they lack a cooperation with el skling.se.</p>
                        <p class="min-min"> It is currently not possible to get our help with the change to this
                            company, as they lack a cooperation with el skling.se.</p>
                        <p class="min-min"> It is currently not possible to get our help with the change to this
                            company, as they lack a cooperation with el skling.se.</p>
                        <p class="min-min"> It is currently not possible to get our help with the change to this
                            company, as they lack a cooperation with el skling.se.</p>
                        <p class="min-min"> It is currently not possible to get our help with the change to this
                            company, as they lack a cooperation with el skling.se.</p>
                        <p class="min-min"> It is currently not possible to get our help with the change to this
                            company, as they lack a cooperation with el skling.se.</p>
                        <p class="min-min"> It is currently not possible to get our help with the change to this
                            company, as they lack a cooperation with el skling.se.</p>
                        <p class="min-min">If you want our free help with changing here and now, we suggest the next
                            possible agreement in your list. For you it is <b>Skellefteå Kraft AB's</b> 36 month agreement.
                            The difference in annual cost is -1223 SEK. Skellefteå Kraft AB's agreement is also an
                            environmental agreement.</p>
                        <p class="min-min">If you want our free help with changing here and now, we suggest the next
                            possible agreement in your list. For you it is <b>Skellefteå Kraft AB's</b> 36 month agreement.
                            The difference in annual cost is -1223 SEK. Skellefteå Kraft AB's agreement is also an
                            environmental agreement.</p>
                        <p class="min-min">If you want our free help with changing here and now, we suggest the next
                            possible agreement in your list. For you it is <b>Skellefteå Kraft AB's</b> 36 month agreement.
                            The difference in annual cost is -1223 SEK. Skellefteå Kraft AB's agreement is also an
                            environmental agreement.</p>
                        <p class="min-min">If you want our free help with changing here and now, we suggest the next
                            possible agreement in your list. For you it is <b>Skellefteå Kraft AB's</b> 36 month agreement.
                            The difference in annual cost is -1223 SEK. Skellefteå Kraft AB's agreement is also an
                            environmental agreement.</p>
                        <p class="min-min">If you want our free help with changing here and now, we suggest the next
                            possible agreement in your list. For you it is <b>Skellefteå Kraft AB's</b> 36 month agreement.
                            The difference in annual cost is -1223 SEK. Skellefteå Kraft AB's agreement is also an
                            environmental agreement.</p>
                        <p class="min-min">If you want our free help with changing here and now, we suggest the next
                            possible agreement in your list. For you it is <b>Skellefteå Kraft AB's</b> 36 month agreement.
                            The difference in annual cost is -1223 SEK. Skellefteå Kraft AB's agreement is also an
                            environmental agreement.</p>
                        <p class="min-min">If you want our free help with changing here and now, we suggest the next
                            possible agreement in your list. For you it is <b>Skellefteå Kraft AB's</b> 36 month agreement.
                            The difference in annual cost is -1223 SEK. Skellefteå Kraft AB's agreement is also an
                            environmental agreement.</p>
                        <p class="min-min">If you want our free help with changing here and now, we suggest the next
                            possible agreement in your list. For you it is <b>Skellefteå Kraft AB's</b> 36 month agreement.
                            The difference in annual cost is -1223 SEK. Skellefteå Kraft AB's agreement is also an
                            environmental agreement.</p>
                        <p class="min-min">If you want our free help with changing here and now, we suggest the next
                            possible agreement in your list. For you it is <b>Skellefteå Kraft AB's</b> 36 month agreement.
                        The difference in annual cost is -1223 SEK. Skellefteå Kraft AB's agreement is also an
                        environmental agreement.</p>
                        <p class="min-min"><b>Would this agreement fit in instead?</b></p>
                    </div>
                    <div class="submit__btn">
                        <div class="row">
                            <div class="col-md-6">
                                <button class="btn btn-gray btn-full small">NO</button>
                            </div>
                            <div class="col-md-6">
                                <button class="btn btn-green btn-full small">AND</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>


<script>
    import OfferResult from "../Partials/OfferResult"
    import PreloaderOffer from "../Partials/preloaderOffer"

    let resultArr = [

        {id:2, name:"2", label: true, image: '//cdn.tecknael.se/images/companies/logos/stockholms_elbolag_ab.svg', typeenergy: true},
        {id:3, name:"3", label: false, image: '//cdn.tecknael.se/images/companies/logos/telinet_energi_ab.svg', typeenergy: false},
        {id:4, name:"4", label: false, image: '//cdn.tecknael.se/images/companies/logos/bestel.svg', typeenergy: false},
    ];
    let resultArr2 = [
        {id:1, name:"1", label: true, image: '//cdn.tecknael.se/images/companies/logos/bestel.svg', typeenergy: true},
    ];

    export default {
        name: "Offer",
        data: function(){
            return {
                preloaded: false,
                preloaded2: false,
                show: false,
                show2: false,
                show3: false,
                show4: false,
                showfilter: false,
                res: resultArr,
                res2: resultArr2,
                modal: false,
                showfilterText: "Show filters",
                // window: {
                //     width: 0,
                //     height: 0
                // }
            }

        },
        components: {
            OfferResult,
            PreloaderOffer
        },
        methods: {
            openModal: function(){
                this.modal = true;

            },
            closeModal: function(){
                this.modal = false;
            },

            preloadBlock(){
               let preloader =  this.preloaded = true;
                let data = this;
                let delay = 1000;
                resultArr.map(function(value, key) {
                    setTimeout(function(){
                        data.res2.push(value);
                        if(resultArr.length == key + 1 ){
                            data.preloaded = false;

                        }
                    }, delay * (key + 1));
                });
                this.preloaded = preloader;
            },
            addElem(elem){

            },
            closetoogleshow(){
                this.show = false
            },
            closetoogleshow2(){
                this.show2 = false
            },
            closetoogleshow3(){
                this.show3 = false
            },
            closetoogleshow4(){
                this.show4 = false
            },
            // handleResize() {
            //     this.window.width = functiopn on offer.innerWidth;
            //     this.window.height = window.innerHeight;
            // },
            showfilters: function(){
              if(this.showfilter){

                  this.showfilterText = "Show filters";
                  this.showfilter = false;

              } else {
                  this.showfilterText = "Hide filters";
                  this.showfilter = true;
              }

            },



        },
        // created() {
        //     window.addEventListener('resize', this.handleResize);
        //     this.handleResize();
        // },
        // destroyed() {
        //     window.removeEventListener('resize', this.handleResize)
        // },



    }
</script>